import Ajax from "Utils/ajax";
export const getShiftMaster = (data) => Ajax.post('setting/getShiftMaster',data); 
export const getAllShiftType = (data) => Ajax.post('setting/getAllShiftType',data);
export const addUpdateShiftMaster = (data) => Ajax.post('setting/addUpdateShiftMaster',data);
export const deleteShift = (data) => Ajax.post('setting/deleteShift',data);